import { Core, OvsComponent, Entity } from './core/ovs.core';
import { ResortImage, ResortImageType, ResortImageFormat, ResortImageTypeDetail } from '../models/presentation.model';
import { ResortApplicationBase } from '../services/resort-application.service';

export class ResortComponent extends OvsComponent
{
    public ResortImageType: typeof ResortImageType = ResortImageType;
    public ResortImageFormat: typeof ResortImageFormat = ResortImageFormat;

    public application: ResortApplicationBase;

    public showLandPrices(): boolean {
        return this.application.configuration.ShowPricing;
    }
    
    constructor()
    {
        super();
    }


    protected initialize(): void
    {
        // Bypass the normal injection by constructor argument approach to avoid affected inheritors of this class.  Can still be replaced during unit testing since we are using the injector.
        this.application = Core.current.getRequiredService<ResortApplicationBase>(ResortApplicationBase);
    }

    public extendedImageExists(images: ResortImageTypeDetail[], types?: ResortImageType[]): string {
        let curImages = images;
        if (curImages && curImages.length > 0) {
            if (types && types.length) {
                curImages = curImages.where(i => types.contains(i.imageType)).toArray();
                if (curImages && curImages.length > 0) {
                    const firstImage = curImages.firstOrDefault(i => !String.isNullOrWhiteSpace(i.description));
                    if (firstImage)
                        return firstImage.title;
                }
            }
        }
        return null;
    }

    public otherExtendedImageExists(images: ResortImage[], types?: ResortImageType[]): boolean {
        let curImages = images;
        if (curImages && curImages.length > 0) {
            if (types && types.length) {
                curImages = curImages.where(i => types.contains(i.imageType)).toArray();
                if (curImages && curImages.length > 0) {
                    return true;
                }
            }
        }
        return false;
    }

    public getFirstImageDescription(images: ResortImage[], types?: ResortImageType[]): string
    {
        if (!images || images.length === 0)
            return "!!!! DESCRIPTION MISSING !!!!";

        if (types && types.length)
            images = images.where(i => types.contains(i.imageType)).toArray();

        if (!images || images.length === 0)
            return "!!!! DESCRIPTION MISSING !!!!";

        const firstImage = images.firstOrDefault(i => !String.isNullOrWhiteSpace(i.description));
        
        if (firstImage)
            return firstImage.description;

        return "!!!! DESCRIPTION MISSING !!!!";
    }

    public getImagesByType(images: ResortImage[], types: ResortImageType[]): ResortImage[]
    {
        if (images && images.length > 0 && types && types.length > 0)
        {
            images = images.where(i => types.contains(i.imageType)).toArray();
        }

        if (images.length > 0)
            return images;

        let dummyImages: ResortImage[] = [];
        let image: ResortImage = new ResortImage();
        image.description = "!!!!  DESCRIPTION MISSING  !!!!";
        image.fileName = "https://ovsmarketingstorage.blob.core.windows.net/images/image_placeholder_itinerary.jpg";
        image.title = "!!!! TITLE MISSING !!!!";
        image.imagePath = -1;
        image.imageFormat = ResortImageFormat.Image;
        dummyImages.add(image);
        dummyImages.add(image);
        dummyImages.add(image);
        return dummyImages;
    }

    public getImages(images: ResortImage[]): ResortImage[]
    {
        if (images.length > 0)
            return images;

        let dummyImages: ResortImage[] = [];
        let image: ResortImage = new ResortImage();
        image.description = "!!!!  DESCRIPTION MISSING  !!!!";
        image.fileName = "https://ovsmarketingstorage.blob.core.windows.net/images/image_placeholder_itinerary.jpg";
        image.title = "!!!! TITLE MISSING !!!!";
        image.imagePath = -1;
        image.imageFormat = ResortImageFormat.Image;
        dummyImages.add(image);
        dummyImages.add(image);
        dummyImages.add(image);
        return dummyImages;
    }

    public getFirstImage(images: ResortImage[]): ResortImage
    {
        if (images && images.length > 0)
            return images.first();

        let image: ResortImage = new ResortImage();
        image.description = "!!!!  DESCRIPTION MISSING  !!!!";
        image.fileName = "https://ovsmarketingstorage.blob.core.windows.net/images/image_placeholder_itinerary.jpg";
        image.title = "!!!! TITLE MISSING !!!!";
        image.imagePath = -1;
        return image;
    }

    // TODO:  Sandbox here and if there are not issues after a while, move to OvsComponent in Core.
    protected new<T extends Entity>(type: { new(): T; }, map: (t: T) => void): T
    {
        let instance: T = new type();
        map(instance);
        return instance;
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/resort.component.ts